import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"


export const CHILDROUTES: Routes = [
    {
        path: 'stores/:store_id/sales', component: LayoutComponent,
        children: [
            {
                "path": "orders/search/:term",
                "loadChildren": "AdminSales/pages/orders/orders.module#OrdersModule",
                canActivate: [OAuth2Service]
            },
            {
                "path": "orders/:order_id",
                "loadChildren": "AdminSales/pages/orders/orders.module#OrdersModule",
                canActivate: [OAuth2Service]
            },
            {
                "path": "invoice-template-management",
                "loadChildren": "AdminSales/pages/invoice-template-management/invoice-template-management.module#InvoiceTemplateManagementModule",
                canActivate: [OAuth2Service]
            },
            {
                "path": "customers/search",
                "loadChildren": "AdminSales/pages/search-customer/search-customer.module#SearchCustomerModule",
                canActivate: [OAuth2Service]
            },
            {
                "path": "customers/:customer_id",
                "loadChildren": "AdminSales/pages/customers/customers.module#CustomersModule",
                canActivate: [OAuth2Service],
            },
            {
                "path": "event-logs/:term",
                "loadChildren": "AdminSales/pages/log-page/log-page.module#LogPageModule",
                canActivate: [OAuth2Service],
            },
            {
                "path": "coupons/:term",
                "loadChildren": "AdminSales/pages/coupons/coupons.module#CouponsModule",
                canActivate: [OAuth2Service],
            },
            {
                "path": "coupons/search",
                "loadChildren": "AdminSales/pages/coupons/coupons.module#CouponsModule",
                canActivate: [OAuth2Service],
            },
            {
                "path": "coupon-report/:term",
                "loadChildren": "AdminSales/pages/coupon-report/coupon-report.module#CouponReportModule",
                canActivate: [OAuth2Service],
            },
            { "path": "clearanceitems", "loadChildren": "AdminSales/pages/returnitem/returnitem.module#ReturnItemModule" },
            {
                "path": "reports",
                "loadChildren": "AdminSales/pages/mat-orderreport/mat-orderreport.module#MatOrderReportModule",
                canActivate: [OAuth2Service]
            },
            {
                "path": "braintree",
                "loadChildren": "AdminSales/pages/mat-braintree-report/mat-braintree-report.module#MatBraintreeReportModule",
                canActivate: [OAuth2Service]
            },
        ],
    },
    {
        path: 'stores/:store_id/sales/invoices',
        children: [
            {
                "path": ":order_id",
                "loadChildren": "AdminSales/pages/bulkinvoice/bulkinvoice.module#BulkInvoiceModule",
                canActivate: [OAuth2Service]
            }
        ]
    },
    {
        path: 'stores/:store_id/sales/invoices-pdf',
        children: [
            {
                "path": ":order_id",
                "loadChildren": "AdminSales/pages/bulkinvoice-pdf/bulkinvoice-pdf.module#BulkinvoicePdfModule",
                canActivate: [OAuth2Service]
            }
        ]
    },
    {
        path: 'stores/:store_id/sales/preview-invoice-pdf',
        children: [
            {
                "path": ":invoice_template_id",
                "loadChildren": "AdminSales/pages/preview-invoice-pdf/preview-invoice-pdf.module#PreviewInvoicePdfModule",
                canActivate: [OAuth2Service]
            }
        ]
    },
];

export const MENUS = [];

